import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import useLanguageChange from "../../hooks/useLanguageChange";
import { PublicVariables } from "../../constants/PublicVariables";
import { setIsChatDrawerOpen } from "../../reducers/common-reducer";
import { resetUnreadChatMsgCount } from "../../reducers/chat-reducer";
import IncomingChatBubble from "../Chat/IncomingChatBubble";
import { CALL_BODY_SCREEN, ENABLED } from "../../constants/Constants";

const ChatButton = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();

    const { isChatDrawerOpen, isRemoteParticipantJoined, currentCallBodyScreen } = useSelector((state) => state.commonReducer);
    const { unreadChatMsgCount } = useSelector((state) => state.chatReducer);

    const handleClickOnChatButton = () => {
        dispatch(setIsChatDrawerOpen(!isChatDrawerOpen));
        dispatch(resetUnreadChatMsgCount());
    };

    return (
        <>
            {PublicVariables.featureFlag?.SHOWMECHAT === ENABLED && (
                <div className='action-button chat-action-button' id='chat-action-button'>
                    <div className='action-button-in'>
                        <button
                            className={clsx("call-action-btn open-sidebar-button", isChatDrawerOpen && "active")}
                            onClick={handleClickOnChatButton}
                            disabled={!isRemoteParticipantJoined || currentCallBodyScreen === CALL_BODY_SCREEN.NOTIFY_SCREEN}
                        >
                            <span className='action-button-icon'>
                                <span className='for-icon icon-chat'></span>
                                {unreadChatMsgCount > 0 && (
                                    <span className='count'>
                                        <span className='count-in'>{unreadChatMsgCount}</span>
                                    </span>
                                )}
                            </span>
                            <span className='for-text'>{localisedValues["chat"]}</span>
                        </button>
                    </div>
                    <IncomingChatBubble />
                </div>
            )}
        </>
    );
};

export default ChatButton;
